export const TabsHeader = (props) => {
  const { tabs, setTabs, tabsContent } = props;

  return (
    <div className="tabs__panel-header">
      <ul>
        {tabsContent.map((item, idx) => {
          return (
            <li onClick={() => setTabs(idx)} className={`${tabs === idx ? 'isActive' : ''}`} key={item.id}>
              <span className="icon">{tabs === idx ? <img alt="" src={`/assets/icons/${item.name.toLowerCase()}-blue.svg`} /> : <img alt="" src={`/assets/icons/${item.name.toLowerCase()}.svg`} />}</span>
              <span className="text">{item.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
